import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7b5c189b from 'nuxt_plugin_plugin_7b5c189b' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_db0dda16 from 'nuxt_plugin_sentryserver_db0dda16' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2cbfa16d from 'nuxt_plugin_sentryclient_2cbfa16d' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_vlazyload_1a3eef42 from 'nuxt_plugin_vlazyload_1a3eef42' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_toast_147260e0 from 'nuxt_plugin_toast_147260e0' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_portalvue_2fea627c from 'nuxt_plugin_portalvue_2fea627c' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_dayjsplugin_4ed448e8 from 'nuxt_plugin_dayjsplugin_4ed448e8' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_axios_48421431 from 'nuxt_plugin_axios_48421431' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_2715b3e2 from 'nuxt_plugin_nuxtsvgsprite_2715b3e2' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_infiniteloading_80126b76 from 'nuxt_plugin_infiniteloading_80126b76' // Source: ../../../plugins/infiniteloading.js (mode: 'client')
import nuxt_plugin_gtag_52bd4c8e from 'nuxt_plugin_gtag_52bd4c8e' // Source: ../../../plugins/g-tag.js (mode: 'client')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../../../plugins/axios.js (mode: 'all')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../../../plugins/vuelidate.js (mode: 'all')
import nuxt_plugin_clickoutside_5b0e370d from 'nuxt_plugin_clickoutside_5b0e370d' // Source: ../../../plugins/click-outside.js (mode: 'all')
import nuxt_plugin_autocompletevue_ae8d5600 from 'nuxt_plugin_autocompletevue_ae8d5600' // Source: ../../../plugins/autocomplete-vue.js (mode: 'all')
import nuxt_plugin_windowsize_572bf26f from 'nuxt_plugin_windowsize_572bf26f' // Source: ../../../plugins/window-size.js (mode: 'all')
import nuxt_plugin_vuebrowsergeolocation_646f1793 from 'nuxt_plugin_vuebrowsergeolocation_646f1793' // Source: ../../../plugins/vue-browser-geolocation.js (mode: 'all')
import nuxt_plugin_globalmodals_0e14ecfe from 'nuxt_plugin_globalmodals_0e14ecfe' // Source: ../../../plugins/global-modals.js (mode: 'all')
import nuxt_plugin_vuexpersist_25bdab30 from 'nuxt_plugin_vuexpersist_25bdab30' // Source: ../../../plugins/vuex-persist.js (mode: 'client')
import nuxt_plugin_smoothpicker_3b7a44c0 from 'nuxt_plugin_smoothpicker_3b7a44c0' // Source: ../../../plugins/smooth-picker.js (mode: 'client')
import nuxt_plugin_vcalendar_4dbed36c from 'nuxt_plugin_vcalendar_4dbed36c' // Source: ../../../plugins/v-calendar.js (mode: 'client')
import nuxt_plugin_websocket_0f1bcf46 from 'nuxt_plugin_websocket_0f1bcf46' // Source: ../../../plugins/websocket.js (mode: 'client')
import nuxt_plugin_lazyimage_85c7d582 from 'nuxt_plugin_lazyimage_85c7d582' // Source: ../../../plugins/lazy-image.js (mode: 'client')
import nuxt_plugin_lazyvideo_34f9561f from 'nuxt_plugin_lazyvideo_34f9561f' // Source: ../../../plugins/lazy-video.js (mode: 'client')
import nuxt_plugin_deviceinfo_15e20f08 from 'nuxt_plugin_deviceinfo_15e20f08' // Source: ../../../plugins/device-info.js (mode: 'client')
import nuxt_plugin_auth_60e5cadf from 'nuxt_plugin_auth_60e5cadf' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_7f7561ce from 'nuxt_plugin_auth_7f7561ce' // Source: ../../../plugins/auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Following App","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"hid":"og-image","name":"og:image","property":"og:image","content":"https:\u002F\u002Fpilot-public-storage-prod.s3.us-east-2.amazonaws.com\u002Fphotos\u002Fwebsite\u002Ffollowing-image.png"},{"hid":"og-title","name":"og:title","property":"og:title","content":"Following - The Social Network for Pilots"},{"http-equiv":"Content-Security-Policy","content":"upgrade-insecure-requests"},{"name":"appleid-signin-client-id","content":"com.followingpilots.auth"},{"name":"appleid-signin-scope","content":"name email"},{"name":"appleid-signin-redirect-uri","content":"https:\u002F\u002Ffollowingpilots.com\u002F"},{"name":"appleid-signin-state","content":"origin:web"},{"name":"appleid-signin-use-popup","content":"true"}],"link":[{"rel":"icon","type":"apple-touch-icon","sizes":"180x180","href":"\u002Fimages\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Fimages\u002Ffavicon\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Fimages\u002Ffavicon\u002Ffavicon-16x16.png"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdnjs.cloudflare.com\u002Fajax\u002Flibs\u002FMaterialDesign-Webfont\u002F7.0.96\u002Fcss\u002Fmaterialdesignicons.min.css"},{"rel":"manifest","href":"\u002Fimages\u002Ffavicon\u002Fsite.webmanifest"},{"hid":"gf-prefetch","rel":"dns-prefetch","href":"https:\u002F\u002Ffonts.gstatic.com\u002F"},{"hid":"gf-preconnect","rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com\u002F","crossorigin":""},{"hid":"gf-preload","rel":"preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Rubik:wght@400;500;600;700"}],"script":[{"src":"https:\u002F\u002Fappleid.cdn-apple.com\u002Fappleauth\u002Fstatic\u002Fjsapi\u002Fappleid\u002F1\u002Fen_US\u002Fappleid.auth.js"},{"hid":"gf-script","innerHTML":"(function(){var l=document.createElement('link');l.rel=\"stylesheet\";l.href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Rubik:wght@400;500;600;700\";document.querySelector(\"head\").appendChild(l);})();"}],"style":[],"noscript":[{"hid":"gf-noscript","innerHTML":"\u003Clink rel=\"stylesheet\" href=\"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Rubik:wght@400;500;600;700\"\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gf-script":["innerHTML"],"gf-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7b5c189b === 'function') {
    await nuxt_plugin_plugin_7b5c189b(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_db0dda16 === 'function') {
    await nuxt_plugin_sentryserver_db0dda16(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2cbfa16d === 'function') {
    await nuxt_plugin_sentryclient_2cbfa16d(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_1a3eef42 === 'function') {
    await nuxt_plugin_vlazyload_1a3eef42(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_147260e0 === 'function') {
    await nuxt_plugin_toast_147260e0(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_2fea627c === 'function') {
    await nuxt_plugin_portalvue_2fea627c(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_4ed448e8 === 'function') {
    await nuxt_plugin_dayjsplugin_4ed448e8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_48421431 === 'function') {
    await nuxt_plugin_axios_48421431(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_2715b3e2 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_2715b3e2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_infiniteloading_80126b76 === 'function') {
    await nuxt_plugin_infiniteloading_80126b76(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_52bd4c8e === 'function') {
    await nuxt_plugin_gtag_52bd4c8e(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  if (typeof nuxt_plugin_clickoutside_5b0e370d === 'function') {
    await nuxt_plugin_clickoutside_5b0e370d(app.context, inject)
  }

  if (typeof nuxt_plugin_autocompletevue_ae8d5600 === 'function') {
    await nuxt_plugin_autocompletevue_ae8d5600(app.context, inject)
  }

  if (typeof nuxt_plugin_windowsize_572bf26f === 'function') {
    await nuxt_plugin_windowsize_572bf26f(app.context, inject)
  }

  if (typeof nuxt_plugin_vuebrowsergeolocation_646f1793 === 'function') {
    await nuxt_plugin_vuebrowsergeolocation_646f1793(app.context, inject)
  }

  if (typeof nuxt_plugin_globalmodals_0e14ecfe === 'function') {
    await nuxt_plugin_globalmodals_0e14ecfe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_25bdab30 === 'function') {
    await nuxt_plugin_vuexpersist_25bdab30(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_smoothpicker_3b7a44c0 === 'function') {
    await nuxt_plugin_smoothpicker_3b7a44c0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vcalendar_4dbed36c === 'function') {
    await nuxt_plugin_vcalendar_4dbed36c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_websocket_0f1bcf46 === 'function') {
    await nuxt_plugin_websocket_0f1bcf46(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyimage_85c7d582 === 'function') {
    await nuxt_plugin_lazyimage_85c7d582(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazyvideo_34f9561f === 'function') {
    await nuxt_plugin_lazyvideo_34f9561f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_deviceinfo_15e20f08 === 'function') {
    await nuxt_plugin_deviceinfo_15e20f08(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_60e5cadf === 'function') {
    await nuxt_plugin_auth_60e5cadf(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_7f7561ce === 'function') {
    await nuxt_plugin_auth_7f7561ce(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
